import { render, staticRenderFns } from "./CustomSelectList.vue?vue&type=template&id=c850f0f8&scoped=true"
import script from "./CustomSelectList.vue?vue&type=script&lang=js"
export * from "./CustomSelectList.vue?vue&type=script&lang=js"
import style0 from "./CustomSelectList.vue?vue&type=style&index=0&id=c850f0f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c850f0f8",
  null
  
)

export default component.exports